import clsx from 'clsx'
import React, {type PropsWithChildren, type ReactElement, Children, cloneElement, Fragment, isValidElement} from 'react'

import styleClasses from './classes.module.css'

type Props = PropsWithChildren<{}>

/** Вставляет между детьми резделители, навешивает на детей класс "withDividers" */
export function WithDividers({children}: Props) {
  const childrenArray = Children.toArray(children).filter(Boolean)

  return (
    <>
      {childrenArray.map((child, index) => (
        <Fragment key={index}>
          {isValidElement(child)
            ? cloneElement(child as ReactElement, {className: clsx(styleClasses.withDividers, child.props.className)})
            : child}

          {index < childrenArray.length - 1 && <div className={styleClasses.divider} />}
        </Fragment>
      ))}
    </>
  )
}
